import { Dayjs } from "dayjs";
import validateEmail from "../Utilities/EmailValidation";

export interface PersonalInfoModel {
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    dateOfBirth: Dayjs | null;
    payoutMethod: string;
    payoutId: string;
}

export interface PersonalInfoErrors {
    firstNameError: boolean;
    lastNameError: boolean;
    emailError: boolean;
    phoneNumberError: boolean;
    dateOfBirthError: boolean;
    payoutMethodError: boolean;
    payoutIdError: boolean;
    errors: string[];
}

export const validatePersonalInfo = async (model: PersonalInfoModel): Promise<PersonalInfoErrors> => {
    
    let errors: PersonalInfoErrors = {
        firstNameError: false,
        lastNameError: false,
        emailError: false,
        phoneNumberError: false,
        dateOfBirthError: false,
        payoutMethodError: false,
        payoutIdError: false,
        errors: []
    }

    // Validate First Name
    if (model.firstName === '') {
        errors.firstNameError = true;
        errors.errors.push('First Name is required');
    }

    // Validate Last Name
    if (model.lastName === '') {
        errors.lastNameError = true;
        errors.errors.push('Last Name is required');
    }

    // Validate Email
    if (model.email === '' || !validateEmail(model.email)) {
        errors.emailError = true;
        errors.errors.push('A valid email is required');
    } 

    // Validate Phone Number
    if (model.phoneNumber === '' || model.phoneNumber.includes('_')) {
        errors.phoneNumberError = true;
        errors.errors.push('A valid Phone Number is required');
    }

    // Validate Date of Birth
    if (model.dateOfBirth === null) {
        errors.dateOfBirthError = true;
        errors.errors.push('Date of Birth is required');
    }

    // Validate Payout Method
    if (model.payoutMethod === '') {
        errors.payoutMethodError = true;
        errors.errors.push('Payout Method is required');
    }

    //Validate PayoutId
    if (model.payoutMethod != '' &&
        model.payoutMethod != 'check' &&
        model.payoutId === '') {
        errors.payoutIdError = true;
        errors.errors.push('Payout Id is required when Payout Method is set to Venmo or PayPal')
    }
    return errors;
}

export const defaultPersonalInfoModel = (email: string) : PersonalInfoModel => {
    return  {
        // Personal Information
        firstName: '',
        middleName: '',
        lastName: '',
        email: email,
        phoneNumber: '',
        dateOfBirth: null,
        payoutMethod: '',
        payoutId: ''
    }
}